import { render, staticRenderFns } from "./package3.vue?vue&type=template&id=194fa0b4&"
import script from "./package3.vue?vue&type=script&lang=js&"
export * from "./package3.vue?vue&type=script&lang=js&"
import style0 from "./package3.vue?vue&type=style&index=0&id=194fa0b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports